import React, { useState, useEffect } from "react";
import "./Footer.scss"

const Footer = (props) => {
  const {currentScreen} = props;

  const [position, setPosition] = useState('absolute');

  useEffect(() => {
    currentScreen === 7 ? setPosition('relative') : setPosition('absolute');
  
  }, [currentScreen])

    return (
      <footer style={{position, top: `${window.innerHeight - 43}px`}}>
        <div id="footer">
          <div className="padding">
            <div className="policy">
              <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" title="" target="_blank">תנאי שימוש</a>{' '}<a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" title="" target="_blank">ומדיניות פרטיות</a>
            </div>
            <div className="yitcredit" onClick={()=> {
                  window.open("https://www.yit.co.il?utm_source=http://source-qa-a.ynet.co.il/short/commerce/backtoschool/&utm_medium=referral&utm_campaign=footer", "_blank");
                }}>
                <div className="text">אפיון, עיצוב ופיתוח</div>
                <div className="yitlogo"></div>
            </div>
          </div>
        </div>
      </footer>
    );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.jsx